import { ChangeEvent, useState } from 'react';
import { convertOneLineDataToCsv } from '../domain/data-converter';

const DataParser = () => {

    const [text, setText] = useState('');
    const [cellsNumber, setCellsNumber] = useState(5);
    const [parsed, setParsed] = useState('');

    const onTextAreaChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        setText(evt.target.value);
        setParsed(convertOneLineDataToCsv(evt.target.value, cellsNumber));
    };

    const onCellsNumberChange = (evt: ChangeEvent<HTMLInputElement>) => {
        setCellsNumber(Number(evt.target.value));
    };

    return (
        <div className="flex flex-col">
            <div className="font-bold my-4">Text line to CSV</div>
            <input
                className="border px-4 py-2 rounded mb-4"
                type="text"
                placeholder="5"
                value={ cellsNumber }
                onChange={ onCellsNumberChange }
            />

            <textarea
                onChange={ onTextAreaChange }
                placeholder="One line data to convert to csv"
                className="border rounded w-full p-2 border border-slate-400 shadow-md text-sm"
                style={ {
                    width: '300px',
                    height: '100px',
                } }
                value={ text }
            />

            {
                <div className="my-4 whitespace-pre-wrap">
                    { parsed }
                </div>
            }
        </div>
    )
};

export default DataParser;